// @flow

import NotFound from "../../notFound/notFound";

type Props = {};

const DisplayPageIfAllowed = (props: Props) => {
	const {allowed} = props
	return allowed ? (
		<>
			{props.children}
		</>
	) : (
		<NotFound/>
	)
};

export default DisplayPageIfAllowed